import styled from "styled-components";

export const Wrapper = styled.div`
.label-text{
    font-size: 15px;
    padding: 4px 3px;
    margin-bottom: 0px;
    margin-top: 10px;

}
  .input-field {
    border: 2px solid gray;
    font-size: 16px;
    padding: 15px 15px;
  }
  .input-field::placeholder{
    font-size: 16px;
  }
  .custom-row {
    display: flex;
    justify-content: center;
  }
  .add-button {
    margin-bottom: 10px;
  }
`;
